import { render, staticRenderFns } from "./SchedulingRiskLocationCard.vue?vue&type=template&id=1f3bc7d2&"
import script from "./SchedulingRiskLocationCard.vue?vue&type=script&lang=js&"
export * from "./SchedulingRiskLocationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports